/**
 * Bundled font registry for OpenDork.
 * Terminal UI only needs Inter (UI) and JetBrains Mono (code/chat).
 */

export interface BundledFont {
  /** Lookup id */
  id: string;
  /** CSS font-family name registered by @fontsource */
  cssFamily: string;
  /** Human label */
  label: string;
  /** Dynamic import that loads the font CSS */
  load: () => Promise<void>;
}

export const BUNDLED_FONTS: BundledFont[] = [
  {
    id: 'inter',
    cssFamily: 'Inter Variable',
    label: 'Inter',
    load: () => import('@fontsource-variable/inter').then(() => {}),
  },
  {
    id: 'jetbrains-mono',
    cssFamily: 'JetBrains Mono Variable',
    label: 'JetBrains Mono',
    load: () => import('@fontsource-variable/jetbrains-mono').then(() => {}),
  },
];

export function findBundledFont(family: string): BundledFont | undefined {
  const lower = family.toLowerCase();
  return BUNDLED_FONTS.find(
    (f) =>
      f.id === lower ||
      f.cssFamily.toLowerCase() === lower ||
      f.label.toLowerCase() === lower ||
      lower.includes(f.id),
  );
}

export async function loadBundledFont(family: string): Promise<BundledFont | undefined> {
  const font = findBundledFont(family);
  if (font) await font.load();
  return font;
}

export function resolveCssFamily(family: string): string {
  return findBundledFont(family)?.cssFamily ?? family;
}
